import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/providers/auth-provider'
import { useWorkspace } from '@/providers/workspace-provider'
import { PageLoader } from '@/components/common/states'
import { CreateWorkspaceScreen } from '@/features/onboarding/create-workspace-screen'

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { session, loading } = useAuth()
  const { memberships, isLoading } = useWorkspace()
  const location = useLocation()

  if (loading)
    return (
      <div className="grid min-h-full place-items-center">
        <PageLoader />
      </div>
    )
  if (!session) return <Navigate to="/entrar" replace state={{ from: location.pathname }} />
  if (isLoading)
    return (
      <div className="grid min-h-full place-items-center">
        <PageLoader label="Carregando workspace…" />
      </div>
    )

  // Usuário autenticado mas sem nenhum workspace → onboarding.
  if (!memberships.length) return <CreateWorkspaceScreen />

  return <>{children}</>
}
